<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="computedQuestion" />
    </template>
    <template #body>
      <BaseTileGrid>
        <BaseTileGridItem type="radio">
          <BaseRadioButton
            v-model="node.inAgeRange"
            value="true"
            :label="computedInAgeRangeLabel"
            :test-id="TestId.booking.ageInRange"
          />
        </BaseTileGridItem>
        <BaseTileGridItem type="radio">
          <BaseRadioButton
            v-model="node.inAgeRange"
            value="false"
            :label="computedOutAgeRangeLabel"
            :test-id="TestId.booking.ageOutOfRange"
          />
        </BaseTileGridItem>
      </BaseTileGrid>
    </template>
  </BaseNode>
</template>

<script setup>
import { computed } from "vue";
import { useI18nInstance } from "#/shared/composables/useI18n";
import { inAgeRangeLabel, outAgeRangeLabel } from "#/shared/utils/ageValidation";
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";
import { TestId } from "#/test-ids";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const { t } = useI18nInstance();
const { processText } = useSnippetProcessor();

const computedQuestion = computed(() => {
  if (props.node.isAgeRangeAnswerMode) {
    return processText(props.node.question, props.decisionTree.context);
  }

  return t("nodes.age_validation.yes_no_answer_mode.question", { inAgeRangeLabel: inAgeRangeLabel(props.node) });
});

const computedInAgeRangeLabel = computed(() => {
  if (props.node.isAgeRangeAnswerMode) {
    return inAgeRangeLabel(props.node);
  }

  return t("nodes.age_validation.yes_no_answer_mode.answer_yes");
});

const computedOutAgeRangeLabel = computed(() => {
  if (props.node.isAgeRangeAnswerMode) {
    return outAgeRangeLabel(props.node);
  }

  return t("nodes.age_validation.yes_no_answer_mode.answer_no");
});
</script>
